import ExampleTheme from "./themes/ExampleTheme";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { AutoFocusPlugin } from "@lexical/react/LexicalAutoFocusPlugin";
import LexicalErrorBoundary from "@lexical/react/LexicalErrorBoundary";
import TreeViewPlugin from "./plugins/TreeViewPlugin";
import ToolbarPlugin from "./plugins/ToolbarPlugin";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { TableCellNode, TableNode, TableRowNode } from "@lexical/table";
import { ListItemNode, ListNode } from "@lexical/list";
import { CodeHighlightNode, CodeNode } from "@lexical/code";
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { MarkdownShortcutPlugin } from "@lexical/react/LexicalMarkdownShortcutPlugin";
import { TRANSFORMERS } from "@lexical/markdown";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import React, { useEffect, useState, useRef } from 'react'
import {
  CAN_REDO_COMMAND,
  CAN_UNDO_COMMAND,
  REDO_COMMAND,
  UNDO_COMMAND,
  SELECTION_CHANGE_COMMAND,
  FORMAT_TEXT_COMMAND,
  FORMAT_ELEMENT_COMMAND,
  $getSelection,
  $isRangeSelection,
  $createParagraphNode,
  $createTextNode,
  $getRoot
} from "lexical";

import { $generateNodesFromDOM } from '@lexical/html';


import ListMaxIndentLevelPlugin from "./plugins/ListMaxIndentLevelPlugin";
import CodeHighlightPlugin from "./plugins/CodeHighlightPlugin";
import AutoLinkPlugin from "./plugins/AutoLinkPlugin";
import { BinaryOperatorToken } from "typescript";
import DocPanel from '../../documentation/DocPanel';
import useApi from '../../api';


function Placeholder() {
  return <div className="text-[#999] overflow-hidden absolute text-ellipsis top-[15px] left-[10px] text-[15px] select-none inline-block pointer-events-none">Write documentation here...</div>;
}

interface EditorProps {
  content: any;
  docId: string | undefined;
  field: any;
  updateSchema: any;
  path: string[];
  mode?: string,
  setModalVisible?: any  
}

export default function ClosedEditor({ content, docId, field, updateSchema, path, mode, setModalVisible }: EditorProps) {
  const [results, setResults] = useState<any>([]);
  const [documents, setDocuments] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { get, getStream, post, postStream, put, patch, remove } = useApi();

  console.log(content)

  const editorConfig = {
    // The editor theme
    theme: ExampleTheme,
    // Handling of errors during update
    editorState: content.value ? JSON.stringify(content.value) : null,
    namespace: `editor-${field.id}-false`,
    onError(error: any) {
      throw error;
    },
    // Any custom nodes go here
    nodes: [
      HeadingNode,
      ListNode,
      ListItemNode,
      QuoteNode,
      CodeNode,
      CodeHighlightNode,
      TableNode,
      TableCellNode,
      TableRowNode,
      AutoLinkNode,
      LinkNode
    ]
  };


  return (
    <LexicalComposer initialConfig={editorConfig}>
        <div className="my-5 border rounded text-black relative leading-5 font-normal text-left rounded-t-lg flex flex-col h-full" style={{ height: "calc(100% - 88px)" }}>
          <ToolbarPlugin content={content} docId={docId} field={field} updateSchema={updateSchema} path={path} mode={mode} setModalVisible={setModalVisible} modalVisible={""} userInput={""} contextDocs={""} setUserInput={""} messageSent={""} setMessageSent={""} />
          <div className="bg-white relative flex flex-row" style={{ height: "calc(100% - 49px)" }}>
            <RichTextPlugin
              contentEditable={<ContentEditable className="min-h-[150px] text-[15px] relative tab-size-1 outline-none p-[15px_10px] caret-[#444] max-h-full overflow-y-auto w-full" />}
              placeholder={<Placeholder />}
              ErrorBoundary={LexicalErrorBoundary}
            />
            <HistoryPlugin />
            <CodeHighlightPlugin />
            <ListPlugin />
            <LinkPlugin />
            <AutoLinkPlugin />
            <ListMaxIndentLevelPlugin maxDepth={7} />
            <MarkdownShortcutPlugin transformers={TRANSFORMERS} />
          </div>
        </div>
    </LexicalComposer>
  );
}
